// Experience Configuration
// Update this file to modify your work experience

export const experiences = [
  {
    title: "Project Lead",
    company: "R Systems",
    type: "Full-time",
    duration: "Apr 2022 - Present",
    period: "3 yrs 11 mos",
    location: "Noida, Uttar Pradesh, India",
    workType: "Hybrid",
    description: "Leading cross-functional teams in developing enterprise-level applications. Architecting scalable solutions for mobile and web platforms, mentoring junior developers, and driving technical decisions. Successfully delivered 5+ major projects with 99.9% uptime.",
    skills: ["Node.js", "React Native", "AWS", "Team Leadership"],
    logo: "R"
  },
  {
    title: "Senior Software Engineer",
    company: "Eeziklit Limited",
    type: "Full-time",
    duration: "Mar 2021 - Mar 2022",
    period: "1 yr 1 mo",
    location: "Noida, Uttar Pradesh, India",
    workType: "Hybrid",
    description: "Built high-performance backend systems handling 100K+ daily active users. Optimized database queries reducing response time by 40%. Implemented real-time features using Socket.io and developed RESTful APIs with comprehensive documentation.",
    skills: ["Node.js", "MongoDB", "Socket.io", "Redis"],
    logo: "E"
  },
  {
    title: "Senior Software Engineer",
    company: "Testovation™",
    type: "Full-time",
    duration: "Oct 2020 - Feb 2021",
    period: "5 mos",
    location: "New Delhi, Delhi, India",
    workType: "Remote",
    description: "Developed responsive web applications for the testing and quality assurance platform. Worked on UI/UX improvements that increased user engagement by 35%. Collaborated remotely with international teams across multiple time zones.",
    skills: ["React.js", "Material-UI", "Jest", "Git"],
    logo: "T"
  },
  {
    title: "Senior Software Engineer",
    company: "Panaesha Capital Pvt. Ltd.",
    type: "Full-time",
    duration: "Nov 2019 - Sep 2020",
    period: "11 mos",
    location: "New Delhi, Delhi, India",
    workType: "On-site",
    description: "Engineered secure fintech solutions with TypeScript and Node.js. Integrated payment gateways processing $1M+ in monthly transactions. Implemented comprehensive unit testing achieving 85% code coverage. Enhanced application security with OAuth 2.0 and JWT.",
    skills: ["Node.js", "TypeScript", "PostgreSQL", "Docker"],
    logo: "P"
  },
  {
    title: "Android and MERN Stack Developer",
    company: "NSS Pvt. Ltd.",
    type: "Full-time",
    duration: "Dec 2013 - Nov 2019",
    period: "6 yrs",
    location: "New Delhi, Delhi, India",
    workType: "On-site",
    description: "Started my professional journey building Android applications from scratch. Evolved into full-stack development with MERN stack. Developed 15+ mobile apps with 500K+ combined downloads. Transitioned from mobile-first to web technologies, mastering the complete software development lifecycle.",
    skills: ["Java", "Android SDK", "MongoDB", "Express", "React", "Node.js"],
    logo: "N"
  }
];

export default experiences;
